import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { MediaQueryService, WB_RESIZE_EVENT_NAME } from '@owc-utils/MediaQueryService';
import { debounce } from '@owc-utils/Events';

const DEFAULT_DEBOUNCE_TIME = 100;
const RESIZE_EVENT = 'resize';

const observer: any = {
  observers: [],
  continuousObservers: [],

  // observer
  subscribe(observers: Array<any>, fn: (state: { items: any[]; total: number }) => void) {
    observers.push(fn);
  },
  notify(observers: Array<any>, detail: any) {
    observers.forEach((observer: any) => observer(detail));
  },
};

const wbMediaQueryService = new MediaQueryService(window);
let isListenerInitialized = false;

const mixin: ThisTypedComponentOptionsWithRecordProps<Vue, {}, {}, {}, {}, {}, {}, {}> = {
  mounted: function() {
    if (!isListenerInitialized) {
      isListenerInitialized = true;
      const notifyEvent = observer.notify.bind(observer);

      // for MQ change
      window.addEventListener(
        WB_RESIZE_EVENT_NAME,
        debounce(DEFAULT_DEBOUNCE_TIME, event => notifyEvent(observer.observers, event), false),
      );

      // for continuous resize
      window.addEventListener(
        RESIZE_EVENT,
        debounce(DEFAULT_DEBOUNCE_TIME, event => notifyEvent(observer.continuousObservers, event), false),
      );

      wbMediaQueryService.observe(true);
    }
  },
  methods: {
    onMQChange: function(listener: EventListenerOrEventListenerObject) {
      observer.subscribe(observer.observers, listener);
    },
    onResize: function(listener: EventListenerOrEventListenerObject) {
      observer.subscribe(observer.continuousObservers, listener);
    },
    getCurrentMediaQuery: function() {
      return wbMediaQueryService.getCurrentMediaQuery();
    },
  },
};

export default mixin;
